import { css, cx } from '@eti/styles';
import { AncillaryRadioGroup, ValidationMessage, vars } from '@etg/wings';
import { useProductCardContext } from '../../../context/ProductCardContext';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const errorMessage = css`
  color: ${vars.colors.signal.critical.foreground};
  font-size: 0.875rem;
  min-height: 1.125rem;
`;
const SingleChoiceToggleBar = _ref => {
  let {
    meta,
    options,
    input,
    legend
  } = _ref;
  const {
    extraProps,
    productName
  } = useProductCardContext();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "buttonWrapper",
      children: /*#__PURE__*/_jsx(AncillaryRadioGroup, {
        "data-testid": "radioToggle-ancillary-radio-group",
        hasError: Boolean((meta === null || meta === void 0 ? void 0 : meta.touched) && (meta === null || meta === void 0 ? void 0 : meta.error)),
        legend: legend,
        name: productName,
        onChange: input.onChange,
        options: options,
        selectedValue: (extraProps === null || extraProps === void 0 ? void 0 : extraProps.selectedValue) || String(input.value)
      })
    }), Boolean((meta === null || meta === void 0 ? void 0 : meta.touched) && (meta === null || meta === void 0 ? void 0 : meta.error)) && /*#__PURE__*/_jsx(ValidationMessage, {
      className: cx(errorMessage, 'validation'),
      "data-testid": "select-option-error-message",
      variant: "error",
      children: meta.error
    })]
  });
};
export default SingleChoiceToggleBar;
//# sourceMappingURL=SingleChoiceToggleBar.js.map